/** @module csi/widget/_svg/GridRight */
define([
	"dojo/_base/declare",
	"dgrid/Grid",
	'dgrid/extensions/DnD',
	"dgrid/Keyboard",
	"dgrid/Selection",
	"dgrid/extensions/DijitRegistry",
	"csi/dgrid/More",
	"./util",
], function(declare,Grid,DnD,Keyboard,Selection,GridDijitRegistry,More,util) {

	return declare([Grid, More, Selection, Keyboard, GridDijitRegistry, DnD], {
		allowSelectAll: true,
		dndSourceType: util.DND_TYPE_IMAGE,
		maintainOddEven: false,
		
		clearDnDHandle: function() {
			const dndSource = this.dndSource;
			if (dndSource && dndSource.anchor) {
				dndSource.anchor.classList.remove("dojoDndItemAnchor");
			}
		},

		showMore: function() {
			this.inherited(arguments);

			const { style } = this.domNode;
			const previousHeight = parseFloat(style.maxHeight);
			// ensure the show more button was just clicked by checking _moreStart > 0 (we don't want to update maxHeight on a grid refresh)
			if (previousHeight && this._moreStart) {
				// the height of each set of 20 images plus padding and margin is about
				// 1200px, we could add 5000px if we wanted, but then the animation would
				// go very fast to accommodate for such a large height. The best height is
				// one that will be a little more than the content, but not too much as to make
				// the animation go too fast.
				style.maxHeight = (previousHeight + 1300) + "px";
			}
		},
	});
});
